import React from "react";
import { socket } from "../../../lib/socketio";
import { Grid } from "semantic-ui-react";
import OptionColumn from "../../Monitor/Data/OptionColumn";
import Footer from "../Footer";
import { useSelector, useDispatch } from "react-redux";
import { useLocation } from "react-router-dom";
import { setCurrentPLC, setUserArray } from "../../../actions/headerActions";
import { setUser } from "../../../actions/navActions";
import RequestAccessModal from "../../RequestAccess/RequestAccessModal";
import { setTE900CEnablePSM1 } from "../../../actions/DataActions";

const ModelActivation_PSM2 = () => {
  const [tags, settags] = React.useState([]);
  const [data, setData] = React.useState([]);
  // const [modtags] = React.useState([8820,8823,8230,8296,8292]); // P, R, I, OPT_HP_EN, OPT_HECOND_EN
  const [modtags] = React.useState([10631, 10632, 10639]);
  const location = useLocation();
  const currentPLC = useSelector((state) => state.header.currentPLC);
  const user = useSelector((state) => state.nav.user);
  const userCopy = useSelector((state) => state.nav.userCopy);
  const electronApp = useSelector((state) => state.nav.electronApp);
  const [userArr, setUserArr] = React.useState(null);
  const [requestor, setRequestor] = React.useState(null);
  const [pop, setPop] = React.useState(false);
  const dispatch = useDispatch();

  React.useEffect(() => {
    dispatch(setCurrentPLC(location.pathname.slice(-4)));
  }, []);

  React.useEffect(() => {
    if (tags.length === 0) {
      socket.emit("get tag names", [{ display_id: 245 }, { display_id: 128 }]);
      socket.on("receive tag names", (data) => {
        settags(data.tags_data);
      });
    }
    return () => {
      socket.removeAllListeners();
    };
  }, [tags]);

  const ids = tags.map((t) => t.id);

  const FooterTags = tags.flatMap((t) => (t.display_id === 128 ? [t] : []));
  FooterTags.sort(
      (a, b) => a.id - b.id,
  );

  const OpTags = tags.flatMap((t) =>
    // t.page_name === 'Option and Model Activation' ? [t] : []);
    t.display_id === 245 ? [t] : [],
  );

  const display = OpTags.map((t) => t.page_name);

  const controlloopswitch = OpTags.filter(
    (el) => el.tag_display_subgroup === "Control Loop Switches",
  );
  // [UPDATE] FR2.0 added mode tags 251118
  const modeoption = OpTags.filter(
    (el) => el.tag_display_subgroup === "MODE DEFINITION",
  );
  const ppoptions = OpTags.filter(
    (el) =>
      el.tag_display_subgroup === "Power Plant Options" ||
      el.tag_display_name === "STACK SELECT" ||
      el.tag_display_name === "SHORT STACK SELECT",
  );
  const RIMode = OpTags.filter((el) => el.tag_display_subgroup === "RI MODE");

  React.useEffect(() => {
    if (!electronApp) {
      var currentClient = `${user.name}:${socket.id}:${userCopy.hmi_role}`;
      socket.on("userDict", (response) => {
        let res = response[currentPLC];

        if (res.indexOf(currentClient) === 1) {
          if (userCopy.hmi_role !== user.hmi_role) {
            user.hmi_role = userCopy.hmi_role;
            dispatch(setUser(user));
          }
        } else {
          dispatch(setUserArray(response));

          for (var i = 2; i < res.length; i++) {
            var info = res[i].split(":");
            if (user.name === info[0]) {
              user.hmi_role = "E";
              setUser(user);
            }
          }
        }
      });
      socket.on("permission", (data) => {
        setUserArr(data.mainArr); // local variable
        setRequestor(data.requestor);
        setPop(true);
      });
      socket.on("access granted", (response) => {
        let data = response[currentPLC];
        if (data.indexOf(currentClient) === 1) {
          user.hmi_role = userCopy.hmi_role;
          dispatch(setUser(user));
        } else {
          dispatch(setUserArray(response));
          user.hmi_role = "E";
          dispatch(setUser(user));
        }
      });
      socket.on("access denied", () => {
        alert("ACCESS DENIED");
      });
      socket.on("access transferred", (data) => {
        alert(
          `Access has been tranferred to ${data.requested.split(":")[0]}. Comment: ${data.comment}`,
        );
      });
    }
    if (ids.length > 0) {
      socket.emit("get tag values", ids);
      socket.on("receive tag values", (value) => {
        setData(value.result);
      });

      return () => {
        socket.removeAllListeners();
      };
    }
  }, [ids, data]);

  // [UPDATE] TE900C Option Enable 251126
  React.useEffect(() => {
    if (ids.length > 0) {
      if (!data[32170]) {
        dispatch(setTE900CEnablePSM1(false));
      } else if (data[32170]) {
        dispatch(setTE900CEnablePSM1(true));
      }
    }
  }, [data]);

  const rows = Math.round(modeoption.length / 2) + 1;
  const rowspa = Math.round(ppoptions.length / 2) + 1;
  const rowsri = Math.round(ppoptions.length / 2) + 1;

  const matags = [];
  const length = modeoption.length;
  let i = 0;
  while (i < length) {
    matags.push(modeoption.slice(i, i + rows));
    i += rows;
  }

  const patags = [];
  const palength = ppoptions.length;
  let pai = 0;
  while (pai < palength) {
    patags.push(ppoptions.slice(pai, pai + rowspa));
    pai += rowspa;
  }

  const ritags = [];
  const rilength = RIMode.length;
  let rii = 0;
  while (rii < rilength) {
    ritags.push(RIMode.slice(rii, rii + rowsri));
    rii += rowsri;
  }

  const handleYes = () => {
    socket.emit("grant access", {
      message: "YES",
      requestor: requestor,
      mainArr: userArr,
      plc: currentPLC,
    });
    setPop(false);
  };
  const handleNo = () => {
    socket.emit("grant access", {
      message: "NO",
      requestor: requestor,
      mainArr: userArr,
      plc: currentPLC,
    });
    setPop(false);
  };

  return (
    <div style={styles.div}>
      {!electronApp && pop && (
        <RequestAccessModal
          pop={pop}
          yes={handleYes}
          no={handleNo}
          reqq={requestor.split(":")[0]}
        />
      )}
      <h1 style={styles.header}>{display[0]}</h1>
      <Grid inverted divided centered columns="equal" style={styles.grid}>
        <Grid.Column
          style={{
            marginLeft: "0px",
            paddingLeft: "0px",
            marginBottom: "0px",
            paddingBottom: "0px",
          }}
        >
          <h3
            style={{
              textAlign: "center",
              color: "white",
              fontWeight: "bold",
              marginTop: "0px",
            }}
          >
            {matags.length > 0 ? matags[0][0].tag_display_subgroup : ""}
          </h3>
          <Grid
            inverted
            divided
            centered
            columns="equal"
            style={{ marginLeft: "0px", paddingLeft: "0px", marginTop: "5px" }}
          >
            {matags.map((c, i) => (
              <OptionColumn
                key={i}
                index={i}
                column={c}
                data={data}
                tags={modtags}
              />
            ))}
          </Grid>
        </Grid.Column>
        <Grid.Column
          style={{
            marginLeft: "0px",
            paddingLeft: "0px",
            marginBottom: "0px",
            paddingBottom: "0px",
          }}
        >
          <h3
            style={{
              textAlign: "center",
              color: "white",
              fontWeight: "bold",
              marginTop: "0px",
              width: "200px",
            }}
          >
            {patags.length > 0 ? patags[0][0].tag_display_subgroup : ""}
          </h3>
          <Grid
            inverted
            divided
            centered
            columns="equal"
            style={{ marginLeft: "0px", paddingLeft: "0px", marginTop: "5px" }}
          >
            {patags.map((c, i) => (
              <OptionColumn
                key={i}
                index={i}
                column={c}
                data={data}
                tags={modtags}
              />
            ))}
          </Grid>
        </Grid.Column>
        <Grid.Column
          style={{
            marginLeft: "0px",
            paddingLeft: "0px",
            marginBottom: "0px",
            paddingBottom: "0px",
          }}
        >
          <h3
            style={{
              textAlign: "center",
              color: "white",
              fontWeight: "bold",
              marginTop: "0px",
            }}
          >
            {ritags.length > 0 ? ritags[0][0].tag_display_subgroup : ""}
          </h3>
          <Grid
            inverted
            divided
            centered
            columns="equal"
            style={{ marginLeft: "0px", paddingLeft: "0px", marginTop: "5px" }}
          >
            {ritags.map((c, i) => (
              <OptionColumn
                key={i}
                index={i}
                column={c}
                data={data}
                tags={modtags}
              />
            ))}
          </Grid>
        </Grid.Column>
      </Grid>
      <div>
        <Footer tags={FooterTags} data={data} />
      </div>
    </div>
  );
};

const styles = {
  div: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    flex: "1 1 auto",
    width: "100%",
  },
  toggle: {
    marginLeft: "8px",
  },
  grid: {
    margin: "0",
  },
  row: {
    padding: "2px 0",
  },
};

export default ModelActivation_PSM2;
